import { useMemo } from 'react'

import { ISitePermitFilterInput } from '~/client/graph'
import { useGetSitePermitFacetsQuery } from '~/client/graph/operations/generated/SitePermits.generated'
import { UNASSIGNED_FILTER_OPTION } from '~/client/src/shared/components/Deliveries/DeliveriesView.store'
import LocationAttributesStore from '~/client/src/shared/stores/domain/LocationAttributes.store'
import { getLocationValues } from '~/client/src/shared/utils/logisticsHelper'

export default function useWorkflowFacets(
  projectId: string,
  filters: ISitePermitFilterInput = {},
  {
    locationAttributesStore,
  }: { locationAttributesStore: LocationAttributesStore },
) {
  const { data, loading: facetsLoading } = useGetSitePermitFacetsQuery({
    variables: {
      filter: {
        projectId,
        ...filters,
      },
    },
    skip: !projectId,
    fetchPolicy: 'network-only',
  })

  const facetsData = useMemo(() => {
    return {
      typeFilters: data?.sitePermitsFacets?.typeFilters || [],
      statusFilters: data?.sitePermitsFacets?.statusFilters || [],
      categoryFilters: data?.sitePermitsFacets?.categoryFilters || [],
      companyFilters: data?.sitePermitsFacets?.companyFilters || [],
      locationFilters:
        data?.sitePermitsFacets?.locationFilters.map(facet => ({
          ...facet,
          key:
            getLocationValues([facet.key], locationAttributesStore)[0] ||
            UNASSIGNED_FILTER_OPTION,
        })) || [],
      equipmentFilters:
        data?.sitePermitsFacets?.equipmentFilters.map(facet => ({
          ...facet,
          key:
            getLocationValues([facet.key], locationAttributesStore)[0] ||
            UNASSIGNED_FILTER_OPTION,
        })) || [],
      assigneeFilters: data?.sitePermitsFacets?.assigneeFilters || [],
      fileFilters: data?.sitePermitsFacets?.fileFilters || [],
    }
  }, [data, locationAttributesStore.allAttributes])

  return { facetsData, facetsLoading }
}
